



















































import Vue from "vue";
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import VueClipboard from 'vue-clipboard2';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

@Component({
  name: "ShareObject"
})
export default class ShareObjectComponent extends Vue {
  @Model() public objectItem!: {objectId: '', objectUrl: '', objectName: ''};
  @Prop(String) public objectSubject: string | undefined;
  @Prop(String) public objectBody: string | undefined;
  @Prop(String) public objectId: string | undefined;
  @Prop(String) public objectUrl: string | undefined;
  @Prop(String) public objectName: string | undefined;
  @Prop(String) public objectExpiration: string | undefined;

  private showMessage = false;
  private messageColor = '';
  private messageText = '';
  private isError = false;
  private user: any;
  private subject = '';
  private body = '';
  private url = '';

  constructor() {
    super();
    this.messageText = '';
    this.showMessage = false;
    this.messageColor = '';
    this.isError = false;

  }

  @Watch('objectItem')
  private getDataObjectItem() {
    this.objectId = this.objectItem.objectId;
    this.objectUrl = this.objectItem.objectUrl;
    this.objectName = this.objectItem.objectName;
    this.getDataRefresh();
  }
  @Watch('objectId')
  private getDataObjectId() {
    this.objectId = this.objectItem.objectId;
    this.objectName = this.objectItem.objectName;
    this.getDataRefresh();
  }
  @Watch('objectUrl')
  private getDataObjectUrl() {
    this.objectUrl = this.objectItem.objectUrl;
    this.objectName = this.objectItem.objectName;
    this.getDataRefresh();
  }

  private mounted() {
    this.getDataRefresh();
  }

  private getDataRefresh() {
    this.user = (this as any).auth.user;
    const name = this.user.name;
    this.url = this.objectUrl === '' ? window.location.origin + '/share/' + this.objectId : '';
    this.subject = this.objectSubject ?? 'Document Translator - Document [' + this.objectItem.objectName + '] shared by [' + name + ']';
    this.body = this.objectBody ?? 'Hi,%0D%0A%0D%0A[' + name + '] wants to share this document with you:%0D%0A';
  }

  public sendMail(): void {
    this.user = (this as any).auth.user;
    // const email = this.user.displayableId;
    const emailBody = this.body +'%0D%0A'+ this.url + '%0D%0A%0D%0A';
    document.location = ("mailto:?subject=" + this.subject + "&body=" + emailBody) as any;
    // document.location = ("mailto:"+email+"?subject="+this.subject+"&body="+emailBody) as any;
  }

  public sendMessage(): void {
    const email = this.user.displayableId;
    // const emailBody = this.emailBody + this.url;
    document.location = ("im:"+email) as any;

  }

  private onCopyMessage(e: any): void {
    this.displayInfo('Copied to Clipboard', false);
    this.sendMessage();
  }

  private onCopy(e: any): void {
    this.displayInfo('Copied to Clipboard', false);
  }

  private displayInfo(text: string, error: boolean) {
    this.messageText = text;
    this.messageColor = error ? 'error' : 'sgsOrange';
    this.showMessage = true;
    this.isError = error;
    if (error) console.error(text, error);
  }
}

Vue.component('share-object', ShareObjectComponent);
